<!--
     <SemicircleChart
       :entries="my_entries"
       :title="my_title"
     />

     entries: [['Potatoe', 3.14], ['Carrots', 2.7]]
-->


<template>
  <highcharts
    class="hc"
    :options="chartOptions"
    ref="chart"
  >
  </highcharts>
</template>

<script>
 export default {
   name: 'SemicircleX',

   props: [
     'value',
     'title',
     'unitats',
     'min',
     'max',
     'color',
   ],

   data: (() => ({
   })),

   computed: {
     end_angle() {
       const start = -90;
       const end   = 90;
       const size  = Math.abs(start) + Math.abs(end);
       return ((this.value - this.min) / (this.max - this.min)) * size + start + .01;
       // We add .01 to prevent a whole circle on this.value == this.min
     },

     center_text() {
       return `${this.value} ${this.unitats}`;
     },

     chartOptions() {
       return {
         chart: {
           backgroundColor: 'transparent',
           plotBackgroundColor: null,
           plotBorderWidth: 0,
           plotShadow: false,
         },

         credits: {
           enabled: false
         },

         title: {
           text: this.center_text,
           align: 'center',
           verticalAlign: 'middle',
           y: 80,
           style: {
             'fontSize': '2.5em',
           }
         },
         tooltip: {
           enabled: false,
           pointFormat: `<b>{point.y:.2f} ${this.unitats}</b>`
         },
         accessibility: {
           point: {
             valueSuffix: '%'
           }
         },
         plotOptions: {
           pie: {
             dataLabels: {
               enabled: false,
               distance: -50,
               style: {
                 fontWeight: 'bold',
                 color: 'white'
               }
             },
             startAngle: -90,
             /* endAngle: this.end_angle, */
             endAngle: 90,
             center: ['50%', '75%'],
             size: '110%',
           }
         },
         series: [{
           type: 'pie',
           name: 'Browser share',
           innerSize: '50%',
           data: [[this.title, this.value], [null, this.max - this.value]],
           colors: [this.color || '#880016', '#edc4cb'],
           enableMouseTracking: false,
         }]
       };
     },
   },

   mounted() {
   },

   methods: {
   },
 }
</script>
